<template>
  <div class="message w-100 d-flex align-items-stretch">
    <div class="avatar">
      <img
        v-if="message.author_type == 'influencer'"
        :src="influencer.avatar"
      >
      <img
        v-if="message.author_type == 'advertiser'"
        :src="advertiser.avatar"
      >
      <img
        v-if="message.author_type == 'system'"
        :src="nativehash.avatar"
      >
    </div>
    <div>
      <div class="d-inline-flex align-items-center">
        <span class="author">
          <span v-if="message.author_type == 'influencer'">{{ influencer.name }}</span>
          <span v-if="message.author_type == 'advertiser'">{{ advertiser.name }}</span>
          <span v-if="message.author_type == 'system'">{{ nativehash.name }}</span>
        </span>
        <span class="date">
          {{ $dateString(message.created_at).join(', ') }}
        </span>
      </div>
      <div v-if="message.author_type == 'system'">
        {{ $t('view-CampaignsMembersMessages.' + message.message) }}
      </div>
      <div v-else>
        <div class="position-relative">
          <div
            v-for="textLine in splitedText"
            :key="textLine"
          >
            {{ textLine }}
          </div>
          <img
            v-if="readed"
            class="readed"
            :src="`${$publicPath}img/campaigns/ok.svg`"
            :title="$t('view-CampaignsMembersMessages.message-readed')"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    campaign: {
      type: Object,
      default: () => { return {} }
    },
    member: {
      type: Object,
      default: () => { return {} }
    },
    message: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {
    nativehash () {
      return {
        name: 'NativeHash',
        avatar: this.$publicPath + 'favicon.png'
      }
    },
    influencer () {
      const influencer = this.member.influencer || null
      return {
        name: influencer.fullName || '',
        avatar: influencer.user.avatar || this.$publicPath + 'img/default-avatar.svg'
      }
    },
    advertiser () {
      const advertiser = this.$store.getters['advertisers/get'](this.campaign.advertiser_id)
      return {
        name: advertiser.user.name || '',
        avatar: advertiser.user.avatar || this.$publicPath + 'img/default-avatar.svg'
      }
    },
    splitedText () {
      return this.message.message.split(/\r?\n/) || ['']
    },
    readed () {
      const isAdvertiser = this.$store.state.user.profile.type === 'advertiser'
      if (this.message.author_type === 'influencer' && !isAdvertiser) {
        return this.message.readed
      } else if (this.message.author_type === 'advertiser' && isAdvertiser) {
        return this.message.readed
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .message {
    margin-bottom: 2rem;
  }
  .avatar {
    margin-right: 1rem;
    img {
      max-width: 50px;
      border-radius: 100%;
    }
  }
  .author {
    font-weight: 600;
  }
  .date {
    display: inline-block;
    margin-left: 0.75rem;
    padding: 0 0.5rem;
    background-color: $warning;
    border-radius: 5px;
    font-size: 0.625rem;
    font-weight: 500;
  }
  .readed {
    position: absolute;
    bottom: -2px;
    right: -14px;
    max-width: 14px;
    opacity: 0.8;
  }
</style>
